import EuroIcon from "@mui/icons-material/Euro";

export const LAYOUT_DIMENSIONS = {
  drawerWidth: 240,
  navbarHeight: 64,
  footerHeight: 40
};

export const acceptedImagesFilesTypes = [
  "image/jpeg",
  "image/png",
  "image/bmp",
  "image/jpg"
];
export const acceptedDocumentFilesTypes = [".pdf", "application/pdf"];
export const acceptedPdfMaxSize = 2000000;
export const acceptedImagesFilesMaxSize = 2097152;

export const DISPLAY_STYLE = {
  grid: "Grid",
  list: "List"
};

export const CURRENCIES_SYMBOLS = {
  usd: "$",
  euro: <EuroIcon fontSize="small" className="mb-1" />
};

export const CURRENCIES_IDS = {
  usd: 1,
  euro: 2
};

export const LANGUAGES = {
  ar: "ar",
  en: "en"
};

export const CHIPS_CLASSES = {
  yellow: "yellow-chip",
  green: "green-chip",
  red: "red-chip",
  blue: "blue-chip",
  grey: "grey-chip",
  orange: "orange-chip",
  pink: "pink-chip",
  purple: "purple-chip",
  darkBlue: "dark-blue-chip",
  darkYellow: "dark-yellow-chip",
  lightBrown: "light-brown-chip"
};

export const PRODUCT_STATUS = {
  pending: "pending",
  published: "published",
  unpublished: "unpublished",
  draft: "draft",
  rejected: "rejected",
  deleted: "deleted"
};

export const PRODUCT_STATUS_IDS = [
  { id: 1, value: "pending" },
  { id: 2, value: "published" },
  { id: 3, value: "unpublished" },
  { id: 4, value: "draft" },
  { id: 5, value: "rejected" },
  { id: 6, value: "deleted" }
];

export const BUSINESS_FILTER_IDS = [
  { id: 1, value: "Factory" },
  { id: 2, value: "Trade" },
  { id: 3, value: "both" }
];

export const EXPORTER_STATUS = {
  registered: 1,
  verified: 2,
  pendingBusinessVerified: 3,
  businessVerified: 4,
  subscribed: 5,
  expired: 6
};

export const REQUEST_STATUS = {
  published: "published",
  pending: "pending",
  rejected: "rejected",
  cancelled: "cancelled"
};

export const REQUEST_STATUS_IDS = [
  { id: 1, value: "published" },
  { id: 2, value: "pending" },
  { id: 3, value: "rejected" },
  { id: 4, value: "cancelled" }
];

export const ATTACHMENTS_TYPES = {
  img: 1,
  video: 2
};

export const SNACKBAR_TYPES = {
  success: "success",
  error: "error",
  info: "info"
};

export const SUB_CATEGORY_PRODUCTS_SORTING = [
  {
    id: 1,
    label: "Most recent",
    value: true
  },
  {
    id: 2,
    label: "Alphabetically",
    value: false
  }
];

export const SORT_PRODUCTS = [
  {
    id: 1,
    label: "Alphabetically",
    value: null
  },
  {
    id: 2,
    label: "Date",
    value: 1
  }
];

export const CATEGORY_REQUEST_STATUS = {
  pending: "pending",
  rejected: "rejected"
};

export const CATEGORY_REQUEST_STATUS_IDS = [
  { id: 2, value: "pending" },
  { id: 3, value: "rejected" }
];

export const USER_TYPES_IDS = {
  admin: 1,
  exporter: 2,
  importer: 3,
  both: 4
};

export const VERIFICATION_METHODS = {
  onlinePayment: 1,
  bankTransfer: 2,
  offPlatform: 3
};

export const OFF_PLATFORM_VERIFICATION_DOCUMENTS_TYPES = {
  image: 1,
  pdf: 2,
  text: 3
};

export const COMPANY_VERIFICATION_STATUS = {
  beforeVerify: null,
  awaitingRequiredDocuments: 1,
  pendingDocumentsUpload: 2,
  documentsUploaded: 3,
  pendingPayment: 4,
  docsNeedUpdates: 5,
  rejected: 6,
  pendingFinalApproval: 7,
  approved: 8
};

export const BUSINESS_VERIFICATION_STATUS_LOCALE_KEYS = {
  1: "awaitRequiredDocuments",
  2: "pendingDocumentsUpload",
  3: "documentsUploaded",
  4: "pendingPayment",
  5: "documentNeedsUpdates",
  6: "rejected",
  7: "pendingFinalApproval",
  8: "accepted"
};

export const generalImporterPagesPadding = "px-md-5 px-4 py-3";

export const BANNER_COLORS = {
  warning: "#DEA71B",
  info: "#0071bc",
  error: "#d32f2f"
};

export const CATEGORY_STATUS_IDS = {
  approved: 1,
  pending: 2,
  rejected: 3
};

export const TRANSACTION_STATUS_IDS = {
  success: 1,
  failure: 3
};
